'use strict';

/*! submenu.js */

function fijaMenu() {
  var topSticky = $('header').height() + $('header').position().top;
  var topBody = $(window).scrollTop();

  // if (topSticky < topBody) {
  //   $('.h-sticky').addClass('fixed')
  //   $('header').css({'margin-bottom': $('.h-sticky').height()})
  // } else {
  //   $('.h-sticky').removeClass('fixed')
  //   $('header').css({'margin-bottom': ''})
  // }
}

function muestraError() {
  if (typeof error_referencia !== 'undefined' && error_referencia === "REF_NOT_FOUND") {
    $('.js-home-error-ref').show();
  }
  if (typeof error_referencia !== 'undefined' && error_referencia === "ACC_NOTFOUND_4_MOI") {
    $('.js-error-ref').show().find('.js-ref').text(ref_pedida);
    $('.js-ref-input').val(ref_pedida);
  }
  if (typeof error_nombre !== 'undefined' && error_nombre === "ACC_NOTFOUND_4_NAME") {
    $('.js-error-nom').show().find('.js-nom').text(nom_pedido);
    $('.js-nom-input').val(nom_pedido);
  }
}

$(function () {
  $('.h-abre-menu').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('li').toggleClass('activo').siblings('li').removeClass('activo');
  });
  $('.nombre-modelo').on('click', function (e) {
    e.preventDefault();
    $('.lista-modelos').slideToggle();
    $('body').toggleClass('no-scroll');
    fijaMenu();
  });
  $('.h-submenu-abierto').on('click', function (e) {
    e.stopPropagation();
  });
  $('body').on('click', function () {
    $('.h-submenu li').removeClass('activo');
  });

  $(window).on('resize', function () {
    fijaMenu();
  });
  $(window).on('scroll', function () {
    fijaMenu();
  });
  muestraError();
});